import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './MobileSubmitButton';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { AppState } from '../../../../types/store';

export type StateProps = Pick<Props, 'hasCoreMembership'>;
export type DispatchProps = Pick<Props, 'openSubmitModal'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  hasCoreMembership: getCurrentUserHasCore(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  props
) => ({
  openSubmitModal: () => dispatch(pushModal(ModalType.DEVIATION_SUBMIT, {})),
});

export default connect(mapStateToProps, mapDispatchToProps);
